
document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('.quick-search').forEach(section => {

    const select = section.querySelector('.custom-select');
    if (!select) return;

    const trigger = select.querySelector('.custom-select__trigger');
    const options = select.querySelector('.custom-options');
    const items = select.querySelectorAll('.custom-option');

    trigger.addEventListener('click', () => {
      options.style.display =
        options.style.display === 'flex' ? 'none' : 'flex';
    });

    items.forEach(item => {
      item.addEventListener('click', () => {
        trigger.querySelector('span').textContent = item.textContent;
        select.dataset.value = item.dataset.value;
        options.style.display = 'none';
      });
    });

    document.addEventListener('click', e => {
      if (!section.contains(e.target)) {
        options.style.display = 'none';
      }
    });

  });


});



/// product page js /////

document.querySelectorAll('.thumb-img').forEach(img => {
  img.addEventListener('click', function() {
    document.getElementById('mainProductImage').src = this.dataset.full;
    document.querySelectorAll('.thumb-img').forEach(i => i.classList.remove('active'));
    this.classList.add('active');
  });
});

document.querySelectorAll('.tab-btn').forEach(btn => {
  btn.addEventListener('click', function() {
    document.querySelectorAll('.tab-btn').forEach(b => b.classList.remove('active'));
    document.querySelectorAll('.tab-content').forEach(c => c.classList.remove('active'));

    this.classList.add('active');
    document.getElementById(this.dataset.tab).classList.add('active');
  });
});

// function thumbSwiper_mainSwiper() {

//     var thumbSwiper = new Swiper(".thumbSwiper", {
//         spaceBetween: 6,
//         slidesPerView: 4,
//         autoHeight: true,
//         direction: "horizontal",
//         watchSlidesProgress: true,
//         breakpoints: {
//             991: {
//                 slidesPerView: 6,
//                 spaceBetween: 8,
//                  direction: "vertical",
//             }
//         }
//     });

//     var mainSwiper = new Swiper(".mainSwiper", {
//         spaceBetween: 12,
//         slidesPerView: 1,
//         autoHeight: true,
//         /* --- ARROW NAVIGATION ACTIVATED HERE --- */
//         navigation: {
//           nextEl: ".swiper-button-next-main",
//           prevEl: ".swiper-button-prev-main",
//         },
//         thumbs: {
//           swiper: thumbSwiper,
//         },
//     });

// };

document.addEventListener("DOMContentLoaded", function () {
  const select = document.getElementById("qtySelect");
  const input = document.querySelector(".quantity__input");
  if (!select || !input) return;
  select.addEventListener("change", function () {
    input.value = this.value;
  });

});



    (function(){

    function applyView(){

      const grid = document.querySelector('#product-grid');
      const buttons = document.querySelectorAll('.view-toggle');

      if (!grid || !buttons.length) return;

      let view = localStorage.getItem('collectionView') || 'list';

      grid.classList.toggle('view-list', view === 'list');

      buttons.forEach(btn=>{
        btn.classList.toggle('active', btn.dataset.view === view);

        btn.onclick = ()=>{
          localStorage.setItem('collectionView', btn.dataset.view);
          applyView(); // reapply instantly
        };
      });

    }

    /* First page load */
    document.addEventListener('DOMContentLoaded', applyView);

    /* Dawn AJAX filter detect */
    const observer = new MutationObserver((mutations)=>{
      for(const m of mutations){
        if(m.addedNodes.length){
          if(document.querySelector('#product-grid')){
            applyView();
            break;
          }
        }
      }
    });

    observer.observe(document.body,{
      childList:true,
      subtree:true
    });

    })();

document.addEventListener("DOMContentLoaded", function () {

  function initPriceSlider() {

    const min = document.getElementById("min");
    const max = document.getElementById("max");
    const range = document.querySelector(".range");
    const minVal = document.getElementById("minVal");
    const maxVal = document.getElementById("maxVal");

    if (!min || !max || min.dataset.initialized) return;

    min.dataset.initialized = "true";
    max.dataset.initialized = "true";

    function updateSlider() {
      let minValue = parseInt(min.value);
      let maxValue = parseInt(max.value);

      if (minValue > maxValue) {
        min.value = maxValue;
        minValue = maxValue;
      }

      const minPercent = (minValue / min.max) * 100;
      const maxPercent = (maxValue / max.max) * 100;

      if (range) {
        range.style.left = minPercent + "%";
        range.style.width = (maxPercent - minPercent) + "%";
      }

      if (minVal) minVal.textContent = "{{ cart.currency.symbol }}" + minValue;
      if (maxVal) maxVal.textContent = "{{ cart.currency.symbol }}" + maxValue;
      
    }

    function applyAjaxFilter() {

      const params = new URLSearchParams(window.location.search);

      params.set("filter.v.price.gte", min.value);
      params.set("filter.v.price.lte", max.value);

      const newUrl = window.location.pathname + "?" + params.toString();

      fetch(newUrl)
        .then(response => response.text())
        .then(html => {

          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");

          const newGrid = doc.querySelector("#product-grid");
          const currentGrid = document.querySelector("#product-grid");

          if (newGrid && currentGrid) {
            currentGrid.innerHTML = newGrid.innerHTML;
          }

          window.history.pushState({}, "", newUrl);

          // 🔥 Re-init after AJAX update
          setTimeout(() => {
            initPriceSlider();
          }, 100);

        });
    }

    min.addEventListener("input", updateSlider);
    max.addEventListener("input", updateSlider);

    min.addEventListener("change", applyAjaxFilter);
    max.addEventListener("change", applyAjaxFilter);

    updateSlider();
  }

  // Initial Load
  initPriceSlider();

  // 🔥 Observe filter updates (Shopify AJAX refresh)
  const observer = new MutationObserver(() => {
    initPriceSlider();
  });

  const filterContainer = document.querySelector(".facets-container");
  if (filterContainer) {
    observer.observe(filterContainer, { childList: true, subtree: true });
  }

});

(function () {

  const input = document.getElementById("customProductSearch");
  const noResults = document.getElementById("noResults");
  const STORAGE_KEY = "collectionSearchValue";

  function normalize(text) {
    return text.toLowerCase().replace(/\s+/g, " ").trim();
  }

  function filterProducts() {

    const value = normalize(input.value);
    const products = document.querySelectorAll("#product-grid .grid__item");

    let matchCount = 0;

    products.forEach(product => {

      const titleEl = product.querySelector(".card__heading a");
      if (!titleEl) return;

      const title = normalize(titleEl.textContent);

      if (value === "") {
        product.classList.remove("hidden-product");
        if(noResults) noResults.style.display = "none";
      } 
      else if (title.startsWith(value)) {
        product.classList.remove("hidden-product");
        matchCount++;
      } 
      else {
        product.classList.add("hidden-product");
      }

    });

    if (value !== "" && noResults) {
      noResults.style.display = matchCount === 0 ? "block" : "none";
    }
  }

  // Save value
  if(input){
      input.addEventListener("input", function () {

        const value = this.value;

        if (value.trim() === "") {
          localStorage.removeItem(STORAGE_KEY);
        } else {
          localStorage.setItem(STORAGE_KEY, value);
        }

        filterProducts();
      });
  }

  // Restore on load
  document.addEventListener("DOMContentLoaded", function () {
    const savedValue = localStorage.getItem(STORAGE_KEY);

    if (savedValue && input) {
      input.value = savedValue;
      filterProducts();
    }
  });

  // 🔥 MAIN FIX — Observe entire body for grid replacement
  const bodyObserver = new MutationObserver(function (mutations) {

    const newGrid = document.querySelector("#product-grid");

    if (newGrid && input) {
      filterProducts();
    }

  });

  bodyObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

})();


let thumbSwiper = null;
let mainSwiper = null;

function waitForElement(selector, callback, timeout = 3000) {
    const start = Date.now();

    (function check() {
        const el = document.querySelector(selector);
        if (el) {
            callback();
        } else if (Date.now() - start < timeout) {
            requestAnimationFrame(check);
        }
    })();
}

function initProductGallerySwiper() {

    const thumbEl = document.querySelector(".thumbSwiper");
    const mainEl = document.querySelector(".mainSwiper");

    if (!thumbEl || !mainEl) return;

    // Destroy old instances
    if (thumbSwiper && thumbSwiper.destroy) {
        thumbSwiper.destroy(true, true);
        thumbSwiper = null;
    }

    if (mainSwiper && mainSwiper.destroy) {
        mainSwiper.destroy(true, true);
        mainSwiper = null;
    }

    thumbSwiper = new Swiper(".thumbSwiper", {
        spaceBetween: 6,
        slidesPerView: 4,
         autoHeight: true,
        direction: "horizontal",
        watchSlidesProgress: true,
        observer: true,
        observeParents: true,
        breakpoints: {
            991: {
                slidesPerView: 6,
                spaceBetween: 8,
                direction: "vertical"
            }
        }
    });

    mainSwiper = new Swiper(".mainSwiper", {
        spaceBetween: 12,
        slidesPerView: 1,
        observer: true,
         autoHeight: true,
        observeParents: true,
        thumbs: {
            swiper: thumbSwiper
        }
    });
}

/* =========================
   SAFE INITIAL LOAD
========================= */

document.addEventListener("DOMContentLoaded", function () {
    waitForElement(".mainSwiper", initProductGallerySwiper);
});

/* =========================
   DAWN AJAX EVENTS
========================= */

document.addEventListener("shopify:section:load", function () {
    waitForElement(".mainSwiper", initProductGallerySwiper);
});

document.addEventListener("cart:refresh", function () {
    waitForElement(".mainSwiper", initProductGallerySwiper);
});

/* =========================
   QUICK ADD FALLBACK
========================= */

document.addEventListener("click", function (e) {
    if (e.target.closest(".quick-add__submit")) {
        setTimeout(function () {
            waitForElement(".mainSwiper", initProductGallerySwiper);
        }, 500);
    }
});



document.addEventListener("DOMContentLoaded", function() {
  const tabs = document.querySelectorAll(".product-tabs .tab-btn");
  const panels = document.querySelectorAll(".product-tabs .tab-panel");
  tabs.forEach(tab => {
    tab.addEventListener("click", function() {
      tabs.forEach(btn => btn.classList.remove("active"));
      panels.forEach(panel => panel.classList.remove("active"));
      this.classList.add("active");
      const target = this.getAttribute("data-tab");
      document.getElementById(target).classList.add("active");
    });
  });
});



/// end product page js ////


document.addEventListener('shopify:section:load', function(event) {
  initProductGallerySwiper();
  thumbSwiper_mainSwiper();
});